import request from "@/api/request";

//提交表单的方法
export const req = (data) => request({
    url: '/api/pushData',
    method: 'post',
    data: data
})
